module.exports = __webpack_public_path__ + "static/media/Lesson-1-15-What-is-the-Heart-Soul-of-the-Church.b85c73f9.pdf";